import { useScreenSize as _useScreenSize } from '@trg/utils';
import { useEffect } from 'react';
import { useLayoutStore } from '../stores';

export function useScreenSize() {
  const setScreen = useLayoutStore.use.setScreen();

  const screen = _useScreenSize();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setScreen(screen), [screen]);

  return screen;
}
